import Button from '@mui/material/Button';

interface Props {
    label: string;
    href: string;
}

export function MicrosoftSignInButton({ label, href }: Props) {
    return (
        <Button
            component="a"
            href={href}
            variant="outlined"
            fullWidth
            data-testid="microsoft-sign-in-button"
            startIcon={<MicrosoftLogo />}
            sx={{
                mb: 2,
                py: 1.25,
                color: '#5E5E5E',
                backgroundColor: '#FFFFFF',
                borderColor: '#D0D0D0',
                borderRadius: 28,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                '&:hover': { backgroundColor: '#F5F5F5', borderColor: '#D0D0D0' }
            }}
        >
            {label}
        </Button>
    );
}

function MicrosoftLogo() {
    return (
        <svg width="18" height="18" viewBox="0 0 21 21" fill="none" aria-hidden="true" data-testid="microsoft-logo">
            <rect width="10" height="10" fill="#F25022" />
            <rect x="11" width="10" height="10" fill="#7FBA00" />
            <rect y="11" width="10" height="10" fill="#00A4EF" />
            <rect x="11" y="11" width="10" height="10" fill="#FFB900" />
        </svg>
    );
}
